import { debounce } from './debounce.js';

/**
 * 窗口自适应模块
 * 监听窗口大小变化，通知渲染器和相机同步更新
 */
export class ResizeHandler {
  /** @type {Function} 绑定的 resize 回调 */
  #onResize;
  /** @type {Function} 防抖处理后的事件回调 */
  #debouncedHandle;

  /**
   * @param {(width: number, height: number) => void} onResize - 窗口变化回调
   */
  constructor(onResize) {
    this.#onResize = onResize;
    this.#debouncedHandle = debounce((width, height) => {
      this.#onResize(width, height);
    }, 200);
  }

  /** 开始监听窗口变化 */
  start() {
    window.addEventListener('resize', this.#handleResize);
  }

  /** 停止监听 */
  stop() {
    window.removeEventListener('resize', this.#handleResize);
  }

  #handleResize = () => {
    this.#debouncedHandle(window.innerWidth, window.innerHeight);
  };
}
